import { Stack, Typography } from '@mui/material';

interface MediaProps {
  title?: string;
  size?: string;
  src: string;
}

const MediaContent = ({ title, size, src }: MediaProps) => {
  const styles = {
    src: {
      borderRadius: '4px',
    },
  };
  return (
    <Stack direction={'row'} spacing={2}>
      <Stack>
        <img
          className="src"
          style={styles.src}
          width={'75px'}
          height={'75px'}
          src={src ? src : ' /placeholder.png'}
        />
      </Stack>
      <Stack justifyContent={'center'}>
        {title ? <Typography>{title}</Typography> : null}
        {size ? (
          <Typography color={'GrayText'}>
            {(Number(size) / 1024 / 1024).toFixed(2)}MB
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};

export default MediaContent;
